export default __webpack_public_path__ + "static/media/sidebar-buynow-bg.5b85c9ce.svg";